// extracted by mini-css-extract-plugin
export default {"body_wrapper":"AutoFit_body_wrapper__UNY6h","wrapper":"AutoFit_wrapper__wLBo2","box":"AutoFit_box__9gJx4"};